<section>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 p-0" *ngIf="globals.loggedIn">
                <app-header></app-header>
            </div>
            <div class="col side-nav" [class.open]="globals.menuOpened" *ngIf="globals.loggedIn">
                <app-side-nav></app-side-nav>
            </div>
            <div class="col  p-0" [class.main-content]="globals.loggedIn" [class.m-0]="!globals.loggedIn"
                [class.open]="globals.menuOpened">
                <main [class.main]="globals.loggedIn">
                    <router-outlet></router-outlet>
                </main>
            </div>
        </div>
    </div>
</section>